import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiEdit2 } from "react-icons/fi";
import { Link } from "react-router-dom";
import Loader from "../../components/Loader";
import Partner from "../../components/Partner";
import axiosInstance from "../../utils/axiosInstance";
import FAQ from "./FAQ";

const Profile = () => {
  const { t } = useTranslation();
  const { languageTab, aboutBatukTab, helpSupportTab } = t("profileTabs");

  const [value, setValue] = useState("2");
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    mobile_number: "",
  });

  useEffect(() => {
    getProfileData();
  }, []);

  const getProfileData = async () => {
    try {
      setLoading(true);
      const getData = await axiosInstance.get("/getProfile");
      const responseData = getData.data.data;
      if (responseData && responseData.length > 0) {
        const item = responseData[0];
        setProfile({
          name: item.fullName,
          email: item.emailAddress,
          mobile_number: item.mobileNumber,
        });
      }
    } catch (error) {
      // console.error("Error fetching profile data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [partnerDetails, setPartnerDetails] = useState(null);

  const getPartnerDetail = async () => {
    try {
      const response = await axiosInstance.post("/augmont/getRm", {
        phone: profile.mobile_number || "",
      });

      if (!response.data.error) {
        setPartnerDetails(response.data);
      }
    } catch (error) {
      console.error("Error fetching partner details:", error);
    }
  };

  useEffect(() => {
    getPartnerDetail();
  }, [profile]);

  if (loading) {
    return (
      <div style={{ height: "80vh" }}>
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <div className="card p-2">
        <Link to="/dashboard/profile/profileSetting">
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              gap: "10px",
            }}
          >
            <div style={{ width: "5.5rem" }}>
              <img src="/images/profileHome.png" width="100%" alt="profile" />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <h6>{profile.name}</h6>
              <h6>{profile.email}</h6>
              <h6>{profile.mobile_number}</h6>
            </div>
            <div className="col-sm-3 d-flex justify-content-center align-items-center">
              <div className="editDiv">
                <FiEdit2 className="editIcon" style={{ color: "#472878" }} />
              </div>
            </div>
          </div>
        </Link>
      </div>
      {/* MY SIP=============  */}
      <Link to="/dashboard/profile/sip-history">
        <div
          style={{
            padding: "0.5rem",
            display: "flex",
            gap: "2rem",
            border: "1px solid lightgray",
            borderRadius: "0.5rem",
            alignItems: "center",
          }}
        >
          <div>
            <img
              src="/images/goldAndSilverSipLogo.png"
              alt="gold_shield"
              width={70}
            />
          </div>
          <h5>My SIP</h5>
        </div>
      </Link>
      {/* REPORTS=============  */}
      <Link to={`/dashboard/profile/report`}>
        <div
          style={{
            padding: "0.5rem",
            display: "flex",
            gap: "2rem",
            border: "1px solid lightgray",
            borderRadius: "0.5rem",
            alignItems: "center",
          }}
        >
          <div>
            <img src="/images/report2.png" alt="gold_shield" width={70} />
          </div>
          <h5>Report</h5>
        </div>
      </Link>
      {/* =======TABS========= */}
      <div className="card profile_card p-2">
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                value={value}
                onChange={(event, newValue) => {
                  setValue(newValue);
                }}
                aria-label="lab API tabs example"
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "black",
                  },
                }}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  "& .MuiTabs-scrollButtons": {
                    "&.Mui-disabled": { opacity: 0.3 },
                  },
                }}
              >
                {/* <Tab
                  label="My Relationship Manager"
                  value="1"
                  sx={{
                    color: "black",
                    borderBottom: "2px solid transparent",
                    "&.Mui-selected": {
                      color: "black",
                      borderBottom: "2px solid black",
                      fontWeight: "bold",
                    },
                  }}
                /> */}
                <Tab
                  value="2"
                  label={<>FAQs</>}
                  sx={{
                    color: "black",
                    textTransform: "none",
                    borderBottom: "2px solid transparent",
                    "&.Mui-selected": {
                      color: "black",
                      borderBottom: "2px solid black",
                      fontWeight: "bold",
                    },
                  }}
                />
              </TabList>
            </Box>
            <TabPanel sx={{ padding: "1rem 0.5rem" }} value="1">
              {/* <Partner
                partnerDetails={partnerDetails}
                getPartnerDetail={getPartnerDetail}
              /> */}
            </TabPanel>
            <TabPanel value="2">
              <FAQ />
            </TabPanel>
          </TabContext>
        </Box>
      </div>
    </div>
  );
};

export default Profile;
